import type { State } from '../State';
import { AllSpecies } from './encyclopedia.ruleset';

export function getSpeciesState(
  state: State,
  species: AllSpecies,
): 'unlocked' | 'veiled' | 'unveiled' {
  return state.encyclopedia.speciesState[species] ?? 'veiled';
}

export function getUnlockedSpecies(state: State): string[] {
  return Object.keys(state.encyclopedia.speciesState).filter(
    (species) => state.encyclopedia.speciesState[species] === 'unlocked',
  );
}

export function getSpeciesNotification(
  state: State,
  species: AllSpecies,
): boolean {
  return state.encyclopedia.speciesNotification[species] ?? false;
} /** True if there is at least one new unlocked pet */
export function hasNewUnlockedPet(state: State): boolean {
  const newPetsIDs = Object.keys(state.encyclopedia.speciesNotification).filter(
    (id) => !!state.encyclopedia.speciesNotification[id],
  );
  return newPetsIDs.some(
    (id) => state.encyclopedia.speciesState[id] === 'unlocked',
  );
}

/** True if there is at least one new unveiled pet */
export function hasNewUnveiledPet(state: State): boolean {
  const newPetsIDs = Object.keys(state.encyclopedia.speciesNotification).filter(
    (id) => !!state.encyclopedia.speciesNotification[id],
  );
  return newPetsIDs.some(
    (id) => state.encyclopedia.speciesState[id] === 'unveiled',
  );
}
